export const isDevStage = window.location.host === 'dev.telemetry.health';
export const isQaStage = window.location.host === 'qa.telemetry.health';
export const isUatStage = window.location.host === 'uat.telemetry.health';
export const isProdStage = window.location.host === 'app.telemetry.health';

export const isDev = process.env.NODE_ENV === 'development' || isDevStage;



// WEBPACK FOOTER //
// ./src/components/utils/env.js